import { useEffect, useState, useRef } from "react"
import {
    doc,
    updateDoc,
} from "firebase/firestore"
import { db } from "../../firebase"
import Button from 'react-bootstrap/Button';
import { handleUpload, handleImageDeletion } from "../../helpers/HelperFunctions";
import AddressAutocompleteProvider from "../helperComponents/AddressAutocompleteProvider";
import DndImage from "../helperComponents/DndImage";
import { getAddressData, getMarkerCoordinates, getZipCode, onAnalyzeImages } from "../../helpers/HelperFunctions";
import {closestCorners, DndContext, KeyboardSensor, PointerSensor, TouchSensor, useSensor, useSensors} from "@dnd-kit/core"
import {SortableContext, arrayMove, sortableKeyboardCoordinates, rectSortingStrategy} from "@dnd-kit/sortable"

const EditListing = ({listing, onHide, setListingItem}) => {
    const [title, setTitle] = useState(listing.title)
    const [price, setPrice] = useState(listing.price)
    const [condition, setCondition] = useState(listing.condition)
    const [description, setDescription] = useState(listing.description)
    const [address, setAddress] = useState(listing.addressData.formattedAddress)
    const [listingImages, setListingImages] = useState(listing.image_urls.map(image => ({url: image, isNew: false, isDeleted: false})))
    // const [imageUrls, setImageUrls] = useState(listing.image_urls)
    // const [uploadFiles, setUploadFiles] = useState([])
    // const [originalImageUrls, setOriginalImageUrls] = useState(listing.image_urls)

    // const listings = useListingsContext().listings
    // const updateListings = useListingsContext().updateListings

    console.log(listingImages)

    const blobUrls = useRef([])
    useEffect(() => {
        return () => {
            console.log("Cleaning up blob URLs...")
            console.log(blobUrls)
            blobUrls.current.forEach(url => URL.revokeObjectURL(url))
        }
    }, [])

    // async function urlToGenerativePart(url, mimeType) {
    //     // 1. Fetch the image data from the URL
    //     const response = await fetch(url);
        
    //     if (!response.ok) {
    //         // This could fail due to an invalid URL or a CORS block by the image host
    //         throw new Error(`Failed to fetch image. Ensure the URL is valid and accessible. Status: ${response.statusText}`);
    //     }
        
    //     const blob = await response.blob();
        
    //     // 2. Convert the Blob to a base64 string
    //     const base64EncodedDataPromise = new Promise((resolve) => {
    //         const reader = new FileReader();
    //         reader.onloadend = () => resolve(reader.result.split(',')[1]); // Extracts ONLY the base64 part
    //         reader.readAsDataURL(blob);
    //     });
    
    //     // 3. Return the structured part object
    //     return {
    //         inlineData: { 
    //             data: await base64EncodedDataPromise, 
    //             mimeType 
    //         },
    //     }
    // }

    // const onAnalyzeImages = async(imageUrls, mimeType = 'image/jpeg') => {
    //     // Provide a prompt that contains text
    //     const promptText = "Analyze these images and return ONLY an array of 5 descriptive tags. Do not include any explanation, introductory text, or markdown formatting. Example output format: `[\"tag1\", \"tag2\", \"tag3\"]`"
    //     const prompt = [promptText]
        
    //     if (imageUrls.length > 1) {
    //         for(let i = 0; i <= 1; i++) {
    //             prompt.push(await urlToGenerativePart(imageUrls[i], mimeType))
    //         }
    //     } else {
    //         prompt.push(await urlToGenerativePart(imageUrls[0], mimeType))
    //     }
    //     console.log(prompt)
      
    //     // To generate text output, call generateContent with the text input
    //     const result = await model.generateContent(prompt);
      
    //     const response = result.response;
    //     const responseText = response.text();
    //     const tagsArray = JSON.parse(responseText)
    //     console.log(tagsArray);
    //     return tagsArray      
    // }

    const onEditSave = async (e) => {
        e.preventDefault()
        console.log(description)
        console.log(listing.id)
        try{
            // let newImageUrls = imageUrls
            // if(uploadFiles.length > 0) {
            //     const uploadedUrls = await handleUpload(uploadFiles)
            //     newImageUrls = imageUrls.concat(uploadedUrls)
            // }

            //upload new images
            const filteredDeletedImages = listingImages.filter(listingImage => listingImage.isDeleted === false)
            const filesToUpload = 
                filteredDeletedImages
                .filter(listingImage => listingImage.isNew)
                .map(listingImage => listingImage.file)
            console.log(filesToUpload)
            let uploadedFilesUrls = []
            if(filesToUpload.length > 0) {
                uploadedFilesUrls = await handleUpload(filesToUpload)
                console.log(uploadedFilesUrls)
            }
            //analyze first 2 images of post
            let iaResult = []
            let imagesAnalyzed = false
            const uploadedFilesUrlsCopy = [...uploadedFilesUrls]
            const originalImageUrls = listing.image_urls
            const newImageUrls = filteredDeletedImages.map(listingImage => {
                if (listingImage.url.split(':')[0] === 'blob') {
                    return uploadedFilesUrlsCopy.shift()
                } else {
                    return listingImage.url
                }}
            )
            if (!(originalImageUrls.slice(0,2).every((value) => newImageUrls.slice(0,2).includes(value)))) {
                const returnedTags = await onAnalyzeImages(newImageUrls)
                iaResult = [...new Set([...returnedTags, ...returnedTags.join(' ').toLowerCase().split(/[\s.,!~/-]/)])]
                imagesAnalyzed = true
            }
            // if(uploadedFilesUrls.length > 0) {
            //     const returnedTags = await onAnalyzeImages(uploadedFilesUrls)
            //     iaResult = [...new Set([...returnedTags, ...returnedTags.join(' ').toLowerCase().split(/[\s.,!~/-]/)])]
            //     imagesAnalyzed = true
            // }

            //delete images from cloudinary
            const imagesToDelete = 
                listingImages
                .filter(listingImage => listingImage.isNew === false && listingImage.isDeleted === true)
                .map(listingImage => listingImage.url)
            // if (imageUrl.split(':')[0] === 'blob') {
            //     const index = uploadFiles.findIndex(file => file.tempUrl === imageUrl)
            //     const uploadFilesCopy = [...uploadFiles]
            //     uploadFilesCopy.splice(index, 1)
            //     setUploadFiles(uploadFilesCopy)
            // } else {
            console.log(imagesToDelete)
            for (const imageUrl in imagesToDelete) {
                const publicId = imageUrl.split("/").pop().split(".")[0]
                handleImageDeletion(publicId)
                // .then(res => {
                //     const index = imageUrls.indexOf(imageUrl)
                //     const imageUrlsCopy = [...imageUrls]
                //     imageUrlsCopy.splice(index, 1)
                //     setImageUrls(imageUrlsCopy)
                // })
            }

            let updateFields = {}
            if(listing.title !== title) {updateFields.title = title}
            if(listing.price !== price) {updateFields.price = price}
            if(listing.condition !== condition) {updateFields.condition = condition}
    
            if(listing.title !== title) {
                updateFields.title = title
                const titleSplit = title.toLowerCase().split(/[\s.,!~/-]/)
                updateFields.titleTags = [...new Set([...titleSplit])]
            }

            if(listing.description !== description) {
                updateFields.description = description
                const descriptionSplit = description.toLowerCase().split(/[\s.,!~/-]/)
                updateFields.descriptionTags = [...new Set([...descriptionSplit])]
            }

            if(imagesAnalyzed) {
                updateFields.aiTags = iaResult
            }
            if (newImageUrls !== listing.image_urls) {
                updateFields.image_urls = newImageUrls
            }
            // const searchArray = [...new Set([...titleSplit, ...descriptionSplit, ...iaResult])]
            
            let addressData
            if (listing.addressData.formattedAddress !== address) {
                addressData = await getAddressData(address)
                const markerCoordinates = getMarkerCoordinates(addressData.coordinates)
                const zipCode = getZipCode(addressData.addressComponents)
                updateFields.markerCoordinates = markerCoordinates
                updateFields.location = addressData.addressComponents[2].long_name
                updateFields.zipCode = zipCode
            }

            await updateDoc(
                doc(db, "listings", listing.id), updateFields
                // {
                //     title: title,
                //     price: price,
                //     condition: condition,
                //     description: description,

                //     // searchArray: searchArray,
                //     // addressData: addressData,
                //     image_urls: newImageUrls,
                //     markerCoordinates: markerCoordinates,
                //     location: addressData.addressComponents[2].long_name,
                //     zipCode: zipCode
                // }
            )
            if (addressData) {
                await updateDoc(
                    doc(db,`listings/${listing.id}/private`, "data"),
                    {
                        addressData: addressData,
                    }
                )
            }
            console.log("Document updated with description: ", description)
            console.log("Document updated with address: ", address)
            
            // const listingIndex = listings.findIndex((e) => e.id === listing.id)
            // const updatedListing = {...listings[listingIndex]}
            // updatedListing.description = description
            // updatedListing.address = address
            // updateListings(listings.toSpliced(listingIndex, 1, updatedListing))
            // setListingItem({...updatedListing})
            // console.log(listing)
            // console.log(updatedListing)
            // console.log(searchArray)
            window.location.reload()

        } catch(err) {
            console.log(err)
        }
        // console.log(description)
        // try {
        //     const body = {description}
        //     const response = await fetch(`http://localhost:5000/listings/${listing.listing_id}`, {
        //         method: "PUT",
        //         headers: {"Content-Type": "application/json"},
        //         body: JSON.stringify(body)
        //     })
        //     console.log(response)
        //     window.location="/"
        // } catch (err) {
        //     console.error(err.message)
        // }
    }

    const MAX_IMAGES = 6
    const handleImageChange = (e) => {
        if(e.target.files) {
            const filesArray = Array.from(e.target.files).map((file) => {
                const blob = URL.createObjectURL(file)
                blobUrls.current.push(blob)
                return {
                    file: file,
                    url: blob,
                    isNew: true,
                    isDeleted: false
                }
            })
            console.log(e.target.files)
            console.log(filesArray)
            const activeImagesCount = listingImages.filter(img => !img.isDeleted).length
            if (activeImagesCount + filesArray.length > MAX_IMAGES) {
                alert(`You can only have a maximum of ${MAX_IMAGES} images`)
                return
            }
            setListingImages((prevImages) => prevImages.concat(filesArray))
        }
    }

    const onImageDelete = (e) => {
        const imageUrl = e.target.getAttribute("imageurl")
        // if (imageUrl.split(':')[0] === 'blob') {
        //     const index = uploadFiles.findIndex(file => file.tempUrl === imageUrl)
        //     const uploadFilesCopy = [...uploadFiles]
        //     uploadFilesCopy.splice(index, 1)
        //     setUploadFiles(uploadFilesCopy)
        // } else {
        //     const publicId = imageUrl.split("/").pop().split(".")[0]
        //     debugger
        //     handleImageDeletion(publicId)
        //     .then(res => {
        //         const index = imageUrls.indexOf(imageUrl)
        //         const imageUrlsCopy = [...imageUrls]
        //         imageUrlsCopy.splice(index, 1)
        //         setImageUrls(imageUrlsCopy)
        //     })
        // }

        setListingImages(prev => prev.map(image => image.url === imageUrl ? {...image, isDeleted : true} : image))
    }

    const getImagePos = (id) => listingImages.findIndex((listingImage) => listingImage.url===id)
    const handleDragEnd = (event) => {
        const { active, over } = event

        if (active.id===over.id) return

        setListingImages((imageUrls) => {
            const originalPos = getImagePos(active.id)
            const newPos = getImagePos(over.id)

            return arrayMove(imageUrls, originalPos, newPos)
        })
    }
    const sensors = useSensors(
        useSensor(PointerSensor, {
            activationConstraint: {
                distance: 5
            }
        }),
        useSensor(TouchSensor, {
            activationConstraint: {
                distance: 5
            }
        }),
        useSensor(KeyboardSensor, {
            coordinateGetter: sortableKeyboardCoordinates
        })
    )

    // const getImageUrlsArray = (imageUrls, uploadFiles) => {
    //     const uploadFilesUrls = uploadFiles.map(file => file.tempUrl)
    //     const imageUrlsArray = imageUrls.concat(uploadFilesUrls)
    //     return imageUrlsArray
    // }
    // const imageUrlsArray = getImageUrlsArray(imageUrls, uploadFiles)
    const imageUrlsArray = listingImages.filter(image => !image.isDeleted).map(image => image.url)
    
    return (
        <>
            <div>Title</div>
            <input 
                type="test" 
                className="form-input" 
                value={title} 
                maxLength={50}
                onChange={e => setTitle(e.target.value)}
            />
            <div>Price</div>
            <input 
                    type="number"    
                    className="form-input"
                    value={price}
                    onChange={
                        e=> setPrice(e.target.value)
                    }
                />
            <div>Condition</div>
            <select
                    type="text"    
                    className="form-input"
                    value={condition}
                    onChange={
                        e=> setCondition(e.target.value)
                    }
                    required
                >
                    <option value="New">New</option>
                    <option value="Used - Like New">Used - Like New</option>
                    <option value="Used - Good">Used - Good</option>
                    <option value="Used - Fair">Used - Fair</option>
                </select>
            <div>Description</div>
            <textarea 
                className="form-input large-input" 
                value={description} 
                maxLength={800}
                onChange={e => setDescription(e.target.value)}
            />
            <div>Pick-up Location</div>
            {/* <input type="test" className="form-input" value={address} onChange={e => setAddress(e.target.value)}/> */}
            <AddressAutocompleteProvider address={address} setAddress={setAddress}/>
            
            <input type="file" id="file-upload" className="hidden-file-input" onChange={handleImageChange} multiple/>
            <label htmlFor="file-upload" className="file-upload-label btn btn-secondary">
                Choose Images
            </label>
            <div className="edit-images-carousel"> 
                <DndContext sensors={sensors} collisionDetection={closestCorners} onDragEnd={handleDragEnd}>
                    <div className="dnd-grid">
                        <SortableContext items={imageUrlsArray} strategy={rectSortingStrategy}>
                            {imageUrlsArray && imageUrlsArray.map((imageUrl, i) => {
                                // return (
                                //     <div 
                                //         className="edit-images-box" 
                                //         key={`edit-images-box-${i}`}
                                //         ref={setNodeRef}
                                //         {...attributes}
                                //         {...listeners}
                                //     >
                                //         <div onClick={onImageDelete} imageUrl={imageUrl} className="x-delete-button">
                                //             <div className="x-container" imageUrl={imageUrl}></div>
                                //         </div>
                                //         <img className="edit-images-thumbnail" src={imageUrl}/>
                                //     </div>
                                // )
                                return (<DndImage key={`edit-images-box-${i}`} id={imageUrl} imageurl={imageUrl} onImageDelete={onImageDelete}/>)
                                }
                            )}
                        </SortableContext>
                    </div>
                </DndContext>
            </div>

            <Button className="btn btn-primary" 
                onClick={
                    (e) => {
                        onEditSave(e)
                        onHide()
                    }
                }
            >Save</Button>
            <Button className="btn btn-secondary" data-bs-dismiss="modal" 
                onClick={
                    () => {
                        setDescription(listing.description)
                        onHide()
                    }
                }
            >Cancel</Button>
        </>

        // <div className="modal fade" id={`id${listing.listing_id}`} tabIndex="-1" aria-labelledby="editListingModal" aria-hidden="true" onClick={() => setDescription(listing.description)}>
        //     <div className="modal-dialog">
        //         <div className="modal-content">
        //         <div className="modal-header">
        //             <h5 className="modal-title" id="editListingModal">Edit Listing</h5>
        //             <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => setDescription(listing.description)}></button>
        //         </div>
        //         <div className="modal-body">
        //             <p>Listing Description</p>
        //             <input type="test" className="form-control" value={description} onChange={e => setDescription(e.target.value)}></input>
        //         </div>
        //         <div className="modal-footer">
        //             <button type="button" className="btn btn-primary" onClick={(e) => onEditClick(e)}>Save</button>
        //             <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" onClick={() => setDescription(listing.description)}>Cancel</button>
        //         </div>
        //         </div>
        //     </div>
        // </div>
    )
}

export default EditListing